package one.healthium.onboarding.domain

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.onboarding.domain.screens.OnboardingGlobalScreenConfig
import one.healthium.onboarding.domain.screens.ScreensGroupModel

@Serializable
data class OnboardingModel(
    @SerialName("id") val id: String,
    @SerialName("config") val config: OnboardingGlobalScreenConfig? = null,
    @SerialName("screens") val screens: List<ScreensGroupModel> = emptyList(),
)
